import { AlertTriangle, Check, Minus, X } from "lucide-react";

import type { ProductOut } from "@/lib/api";
import {
  buyboxOutcome,
  priceSetterLabel,
  priceSetterStatus,
  type PriceSetterStatus,
} from "@/lib/buybox";
import { cn } from "@/lib/utils";

// Mapping stato price-setter -> stile pill (icona + colore, mai colore da solo).
const PRICE_SETTER_PILL: Record<
  PriceSetterStatus,
  { cls: string; Icon: typeof Check }
> = {
  at_margin: { cls: "pill-ok", Icon: Check }, // prezzo al target a margine
  off_margin: { cls: "pill-risk", Icon: AlertTriangle }, // da correggere
  no_floor: { cls: "pill-neutral", Icon: Minus }, // costo ignoto: nessun target
};

// Due percorsi:
//  - Canali PRICE-SETTER (BricoBravo, senza competitor): "A margine" /
//    "Da correggere" / "No costo" (lo stato riflette il margine, non la buybox).
//  - Canali con competitor: SOLO 2 stati "Buybox vinta"/"Buybox persa" (o "—"
//    se non vendiamo li'). Il backend tiene gli stati granulari; qui si collassa.
export function StatusBadge({ product }: { product: ProductOut }): JSX.Element {
  const ps = priceSetterStatus(product);
  if (ps !== null) {
    const { cls, Icon } = PRICE_SETTER_PILL[ps];
    return (
      <span className={cn("pill", cls)}>
        <Icon className="h-3 w-3 shrink-0" strokeWidth={2.5} aria-hidden="true" />
        {priceSetterLabel(ps)}
      </span>
    );
  }

  const outcome = buyboxOutcome(product);
  if (outcome === null) {
    return (
      <span className="text-muted-foreground" aria-label="Non in vendita su questo marketplace">
        —
      </span>
    );
  }
  const isWon = outcome === "won";
  const Icon = isWon ? Check : X;
  return (
    <span className={cn("pill", isWon ? "pill-ok" : "pill-out")}>
      <Icon className="h-3 w-3 shrink-0" strokeWidth={2.5} aria-hidden="true" />
      {isWon ? "Buybox vinta" : "Buybox persa"}
    </span>
  );
}
